import React from 'react'

import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import {
  Typography,
  TextField,
  CircularProgress,
  Box,
  Paper,
  makeStyles,
  Link,
} from '@material-ui/core'

import schemas from './../../../schemas'
import Summary from './../Summary'
import Footer from './../Footer'
import useWindowSize from 'hooks/useWindowSize'
import useSubscribe from 'hooks/useSubscribe'
import useSnackbar from 'hooks/useSnackbar'
import styles from './styles'

const useStyles = makeStyles(styles)

const Identification = () => {
  const classes = useStyles()
  const windowSize = useWindowSize()
  const snackbar = useSnackbar()
  const subscribe = useSubscribe()
  const [isLoading, setIsLoading] = React.useState(false)
  const { register, setValue, handleSubmit, errors } = useForm({
    validationSchema: subscribe.requireLogin
      ? schemas.subscribeStepIdentificationLogin
      : schemas.subscribeStepIdentification,
    defaultValues: {
      email: (subscribe.customer && subscribe.customer.email) || '',
    },
  })

  React.useEffect(() => {
    if (!subscribe.authenticated) {
      return
    }

    subscribe.nextStep()
  }, [subscribe])

  const login = async data => {
    try {
      setIsLoading(true)

      await subscribe.login(data)

      setIsLoading(false)

      subscribe.setEditData(true)
    } catch (error) {
      setIsLoading(false)

      if (error && error.response && error.response.status === 401) {
        snackbar.open({
          message: 'Email ou senha inválidos',
          variant: 'error',
        })

        return
      }

      snackbar.open({
        message: 'Ocorreu algum erro! Tente novamente!',
        variant: 'error',
      })
    }
  }

  const loginWithEmail = async data => {
    try {
      setIsLoading(true)

      await subscribe.loginWithEmail(data)

      subscribe.nextStep()
      subscribe.setEditData(false)

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)

      if (error && error.response && error.response.status === 404) {
        subscribe.setCustomer({
          email: data.email,
        })

        subscribe.nextStep()

        return
      }

      snackbar.open({
        message: 'Ocorreu algum erro! Tente novamente!',
        variant: 'error',
      })
    }
  }

  const handleClickPrevButton = () => {
    subscribe.setRequireLogin(false)
    subscribe.backStep()
  }

  const handleClickLinkCancelLogin = event => {
    event.preventDefault()

    loginWithEmail({ email: subscribe.customer.email })
  }

  const onSubmit = async data => {
    if (subscribe.requireLogin) {
      login(data)
      return
    }

    return loginWithEmail(data)
  }

  if (subscribe.isLoadingLoginWithTokenCached) {
    return (
      <Box
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress size={40} />
      </Box>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.container}>
        <Paper
          elevation={windowSize.isDesktop ? 1 : 0}
          className={classes.content}
        >
          <div>
            <Typography
              variant="h4"
              color="textSecondary"
              className={classes.title}
            >
              Informe seu e-mail
            </Typography>

            <RHFInput
              as={
                <TextField
                  label="E-mail"
                  error={!!errors.email}
                  helperText={errors && errors.email && errors.email.message}
                  className={classes.field}
                  fullWidth
                />
              }
              name="email"
              register={register}
              setValue={setValue}
              mode="onChange"
            />

            {subscribe.requireLogin && (
              <>
                <RHFInput
                  as={
                    <TextField
                      label="Senha"
                      type="password"
                      error={!!errors.password}
                      helperText={
                        errors && errors.password && errors.password.message
                      }
                      className={classes.field}
                      fullWidth
                    />
                  }
                  name="password"
                  register={register}
                  setValue={setValue}
                  mode="onChange"
                />

                <Typography
                  color="secondary"
                  className={classes.linkCancelLogin}
                >
                  <Link href="#" onClick={handleClickLinkCancelLogin}>
                    Continuar sem editar os dados
                  </Link>
                </Typography>
              </>
            )}
          </div>
        </Paper>

        <Summary className={classes.summary} showPlans />
      </div>

      <Footer
        prevButtonProps={{ onClick: handleClickPrevButton }}
        nextButtonText={isLoading ? 'Carregando...' : 'Continuar'}
        nextButtonProps={{ disabled: isLoading }}
        className={classes.footer}
      />
    </form>
  )
}

export default Identification
